import { Amazon, Blockquote, VocabularyFooter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  VocabularyFooter,
  React
};